<script setup lang="ts">
  import type { NuxtError } from '#app'

  const props = defineProps<{
    error: NuxtError
  }>()

  const { t, locale } = useI18n()
  const route = useRoute()

  const statusCode = computed(() => props.error?.statusCode || 500)
  const is404 = computed(() => statusCode.value === 404)
  const isAdmin = computed(() => /^(\/[a-z]{2})?\/admin(\/|$)/.test(route.path))

  useHead({
    title: () => {
      if (isAdmin.value) {
        return is404.value ? '页面不存在 - 管理后台' : '出错了 - 管理后台'
      }
      return is404.value ? t('error.title404') : t('error.titleGeneric')
    },
    htmlAttrs: {
      lang: () => (locale.value === 'en' ? 'en-US' : 'zh-CN'),
    },
  })
</script>

<template>
  <div v-if="isAdmin" class="admin-error-root admin-font">
    <AppAdminProvider>
      <div class="admin-error-root__inner">
        <AppAdminErrorState :status-code="statusCode" clear-on-navigate />
      </div>
    </AppAdminProvider>
  </div>
  <div v-else>
    <AppHeader />
    <div class="page-offset" aria-hidden="true" />
    <AppErrorState :status-code="statusCode" clear-on-navigate />
    <AppFooter />
  </div>
</template>

<style scoped>
  .page-offset {
    height: 140px;
  }

  .admin-error-root {
    box-sizing: border-box;
    min-height: 100vh;
    background: #f0f5f9;
  }

  .admin-error-root__inner {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px;
  }
</style>
